// extracted by mini-css-extract-plugin
module.exports = {"notice":"Ap2ch","body":"_2KCeY","close":"_3T8HY","content":"_2BvSl","title":"_3EJTf","ok":"_1_ZAA","link":"_-0WE5"};